<template>
  <div class="default-wrapper">
    <h3>Panel główny</h3>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {}
}
</script>

<style lang="less">
	.default-wrapper {
		padding: 1.5rem;
		background-color: #e9ecef;
		flex: 1 1 auto;
	}
</style>